import Desktop from './Desktop';
import Mobile from './Mobile';
import ComponentWrapper from './ComponentWrapper';

export { Desktop, Mobile };
